import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { FaCheckCircle, FaExclamationTriangle, FaSpinner, FaBriefcaseMedical } from 'react-icons/fa';
import api from '../services/api';

const PRIMARY = '#E8500A';
const SECONDARY = '#FF6B2C';
const DARK = '#1a1a2e';
const MUTED = '#8888a8';

const VerifyEmail = () => {
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');
  const [loginPath, setLoginPath] = useState('/patient/login');
  const location = useLocation();
  const navigate = useNavigate();

  const hasRun = useRef(false);

  useEffect(() => {
    const verifyToken = async () => {
      if (hasRun.current) return;
      hasRun.current = true;

      const params = new URLSearchParams(location.search);
      const token = params.get('token');

      if (!token) {
        setStatus('error');
        setMessage('Verification token is missing.');
        return;
      }

      try {
        const res = await api.get(`/auth/verify-email?token=${token}`);
        const role = res.data.role || 'Patient';
        setLoginPath(`/${role.toLowerCase()}/login`);
        setStatus('success');
        setMessage(res.data.message || 'Email verified successfully!');
      } catch (err) {
        setStatus('error');
        setMessage(err.message || 'Verification failed. The link may be expired.');
      }
    };

    verifyToken();
  }, [location.search]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f0f2f5',
      padding: '20px',
      fontFamily: "'Segoe UI', sans-serif"
    }}>
      <div style={{
        maxWidth: '450px',
        width: '100%',
        background: 'white',
        borderRadius: '24px',
        padding: '48px 40px',
        textAlign: 'center',
        boxShadow: '0 24px 80px rgba(0,0,0,0.1)'
      }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '30px' }}>
          <div style={{
            width: 50, height: 50, borderRadius: 12,
            background: `linear-gradient(135deg,${PRIMARY},${SECONDARY})`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 4px 14px rgba(232,80,10,0.32)',
          }}>
            <FaBriefcaseMedical size={22} color="white" />
          </div>
        </div>

        {status === 'loading' && (
          <>
            <FaSpinner size={40} color={PRIMARY} className="fa-spin" style={{ marginBottom: '20px' }} />
            <h2 style={{ color: DARK }}>Verifying Email...</h2>
            <p style={{ color: MUTED }}>Please wait while we verify your account.</p>
          </>
        )}

        {status === 'success' && (
          <>
            <FaCheckCircle size={50} color="#28a745" style={{ marginBottom: '20px' }} />
            <h2 style={{ color: DARK }}>Verified!</h2>
            <p style={{ color: MUTED, marginBottom: '30px' }}>{message}</p>
            <button
              onClick={() => navigate(loginPath)}
              style={{
                display: 'block', width: '100%',
                padding: '14px 0',
                background: `linear-gradient(135deg,${PRIMARY},${SECONDARY})`,
                color: 'white', border: 'none',
                borderRadius: '10px', cursor: 'pointer',
                textDecoration: 'none',
                fontWeight: 700,
                boxShadow: '0 4px 18px rgba(232,80,10,0.35)'
              }}
            >
              Go to Login
            </button>
          </>
        )}

        {status === 'error' && (
          <>
            <FaExclamationTriangle size={50} color="#dc3545" style={{ marginBottom: '20px' }} />
            <h2 style={{ color: DARK }}>Verification Failed</h2>
            <p style={{ color: MUTED, marginBottom: '30px' }}>{message}</p>
            <Link to="/patient/login" style={{ color: PRIMARY, fontWeight: 700, textDecoration: 'none' }}>
              Back to Login
            </Link>
          </>
        )}
      </div>
      <style>{`
        @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
        .fa-spin { animation: spin 1s infinite linear; }
      `}</style>
    </div>
  );
};

export default VerifyEmail;
